let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("19wPE")).then(() => parcelRequire('31248'));